import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
// import Loaders from "../Loaders";
import BreadcrumTop from "../BreadcrumTop";
import Swal from "sweetalert2";
import { getToken } from "../../../utils/getToken";
import { API_ROUTES } from "../../../utils/constants";
import { apiFetch } from "../../../utils/apiFetch";

export default function CreateMarketers(props) {
  const { isLoaded, setIsLoaded } = props;

  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [companyId, setCompanyId] = useState("");
  // newly added
  const [unitPrice, setUnitPrice] = useState("");
  const [payload, setPayload] = useState([{ key: "", value: "" }]);

  // Toggle password visibility
  const togglePassword = () => setShowPassword(!showPassword);

  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;

  useEffect(() => {
    if (rowData) {
      //  console.log("Company ID:", companyId);
    }
  }, [rowData]);

  useEffect(() => {
    // Retrieve userVASData from localStorage
    const userVASDataString = localStorage.getItem("userVASData");

    if (userVASDataString) {
      try {
        // Parse the JSON string
        const userVASData = JSON.parse(userVASDataString);

        // Extract the id from responseDetails
        const id = userVASData?.responseDetails?.id;

        if (id) {
          setCompanyId(id || "");
          // console.log("Company ID:", id);
        }
      } catch (error) {
        console.error("Error parsing userVASData:", error);
      }
    }
  }, []);

  useEffect(() => {
    // Retrieve companyVASData from localStorage
    const storedCompanyVASData = localStorage.getItem("companyVASData");

    if (storedCompanyVASData) {
      try {
        const parsedData = JSON.parse(storedCompanyVASData);
        if (parsedData?.id) {
          setCompanyId(parsedData.id);
          setCompanyName(parsedData.companyName);
          // console.log("Loaded companyId from localStorage:", parsedData.id);
          // console.log(
          //   "Loaded company name from localStorage:",
          //   parsedData.companyName
          // );
        }
      } catch (error) {
        console.error("Error parsing companyVASData:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (companyId) {
      // console.log("Company ID:", companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (window.eduMin) {
      window.eduMin.load();
    } else {
      console.warn("eduMin is not defined");
    }
  }, []);

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([loadScript("../assets/libs_/js/custom.min.js")])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      // Remove the scripts here if necessary
    };
  }, []);

  const handleInputChange = (index, field, value) => {
    const newPayload = [...payload];
    newPayload[index][field] = value;
    setPayload(newPayload);
  };

  // Add New Payload Row
  const handleAddPayload = () => {
    setPayload([...payload, { key: "", value: "" }]);
  };

  // Remove Payload Row
  const handleRemovePayload = (index) => {
    if (payload.length > 1) {
      const newPayload = payload.filter((_, i) => i !== index);
      setPayload(newPayload);
    }
  };

  // Validation function
  const validateForm = () => {
    if (!name) return showError("Name is required.");
    if (!email) return showError("Email is required.");
    if (!email.includes("@"))
      return showError("Please enter a valid email address.");

    if (!unitPrice || isNaN(unitPrice) || Number(unitPrice) <= 0) {
      return alert("Please enter a valid Unit Price greater than 0");
    }

    if (!url) return showError("URL is required.");

    // Validate URL format
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/\S*)?$/;
    if (!urlRegex.test(url)) return showError("Please enter a valid URL.");
    if (!payload || payload.length === 0)
      return showError("At least one payload entry is required.");

    for (let i = 0; i < payload.length; i++) {
      let { key, value } = payload[i];

      // Ensure key and value are strings
      key = String(key);
      value = String(value);

      if (!key.trim()) return showError(`Key is required for row ${i + 1}.`);
      if (!value.trim())
        return showError(`Value is required for row ${i + 1}.`);
    }
    if (password.length < 6)
      return showError("Password must be at least 6 characters.");
    // Password validation regex
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{6,}$/;
    if (!passwordRegex.test(password)) {
      return showError(
        "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
    }

    // key and value
    for (let i = 0; i < payload.length; i++) {
      let { key, value } = payload[i];

      // Ensure key and value are strings
      key = String(key);
      value = String(value);

      if (!key.trim()) return showError(`Key is required for row ${i + 1}.`);
      if (!value.trim())
        return showError(`Value is required for row ${i + 1}.`);
    }
    return true;
  };

  const showError = (message) => {
    Swal.fire({ title: "Error", text: message, icon: "error" });
    return false;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific items from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    setLoading(true);
    const payloadd = payload.reduce((acc, { key, value }) => {
      if (key.trim() && value.trim()) acc[key] = value;
      return acc;
    }, {});
    const payloadToSend = Object.entries(payloadd)
      .map(([key, value]) => `${key}:${value}`)
      .join("; ");

    const formData = {
      name,
      url,
      email,
      companyId: companyId,
      password,
      payload: payloadToSend,
    };
    //  console.log("form data to submit", formData);

    try {
      const response = await apiFetch(API_ROUTES.CREATE_MARKETER, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      // console.log("Form Data:", JSON.stringify(formData, null, 2));
      if (!response.ok) {
        const errorMessages = {
          400: "Bad Request. Please check your input.",
          401: "Unauthorized. Please log in again.",
          404: "Not Found. The requested resource could not be found.",
          500: "Internal Server Error. Please try again later.",
          503: "Service Unavailable. Please try again later.",
        };

        throw new Error(errorMessages[response.status] || "Unexpected error.");
      }

      const responseJSON = await response.json();

      if (response.ok) {
        Swal.fire({
          title: "Success",
          text: "Marketer created successfully.",
          icon: "success",
        }).then(() => {
          navigate("/marketers", {
            state: {
              rowData: {
                id: companyId,
                companyName: companyName,
              },
            },
          });
        });
      } else {
        Swal.fire({
          title: "Error",
          text: responseJSON.message || "Unable to create marketer.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error creating marketer:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "An unexpected error occurred.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Loaders isLoaded={isLoaded} /> */}

      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body">
          <div className="container-fluid">
            <BreadcrumTop title="Onboard Marketer" />

            <div className="row">
              <div className="d-flex justify-content-center align-items-center">
                <div className="col-xl-7 col-lg-10 col-md-10">
                  <div className="card ">
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="mb-2 row">
                          <div className="col-sm-10 offset-sm-2">
                            <p className="text-danger">
                              All fields are compulsory
                            </p>
                          </div>
                        </div>
                        <input
                          type="hidden"
                          name="companyId"
                          value={companyId}
                          className="form-control"
                        />
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter name"
                              // required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Email
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="email"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter email"
                              // required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">
                            Password
                          </label>
                          <div className="col-sm-5 position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control pe-5"
                              placeholder="Enter password"
                            />
                            <span
                              className="show-pass eye position-absolute top-50 end-0 translate-middle-y"
                              onClick={togglePassword}
                              style={{
                                cursor: "pointer",
                                paddingRight: "24px",
                              }}
                              aria-label="Toggle password visibility"
                            >
                              {showPassword ? (
                                <i className="fa fa-eye"></i>
                              ) : (
                                <i className="fa fa-eye-slash"></i>
                              )}
                            </span>
                          </div>
                          <label className="col-sm-2 col-form-label">
                            Unit price
                          </label>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              name="unitPrice"
                              value={unitPrice}
                              onChange={(e) => {
                                const value = e.target.value.trim();

                                if (/^\d*\.?\d*$/.test(value) || value === "") {
                                  setUnitPrice(value);
                                }
                              }}
                              className="form-control"
                              placeholder="Enter unit price"
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="col-sm-2 col-form-label">URL</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="url"
                              value={url}
                              onChange={(e) => setUrl(e.target.value)}
                              className="form-control"
                              placeholder="Enter company URL"
                              // required
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3">
                          <label className="col-sm-2 col-form-label">
                            PAYLOAD
                          </label>

                          {payload.map((item, index) => (
                            <div
                              className="row mb-2 align-items-center"
                              key={index}
                            >
                              <div className="col-sm-5">
                                <label className="col-sm-2 col-form-label">
                                  Key
                                </label>
                                <input
                                  type="text"
                                  value={item.key}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "key",
                                      e.target.value
                                    )
                                  }
                                  className="form-control"
                                  placeholder="Enter key"
                                />
                              </div>

                              <div className="col-sm-5 mt-2">
                                <label className="form-label">Value</label>
                                <input
                                  type="text"
                                  value={item.value}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "value",
                                      e.target.value
                                    )
                                  }
                                  className="form-control"
                                  placeholder="Enter value"
                                />
                              </div>

                              <div className="col-md-1 d-flex align-items-center gap-1 mt-4 justify-content-center">
                                <i
                                  className="la la-minus"
                                  onClick={() => handleRemovePayload(index)}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    padding: "5px",
                                    color: "white",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "5px",
                                    cursor:
                                      index === 0 ? "not-allowed" : "pointer",
                                    opacity: index === 0 ? 0.5 : 1,
                                  }}
                                ></i>

                                {index === payload.length - 1 && (
                                  <i
                                    className="la la-plus"
                                    onClick={handleAddPayload}
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      backgroundColor: "blue",
                                      padding: "5px",
                                      color: "white",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                  ></i>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mb-3 mt-4 row">
                          <div className="col-sm-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary m-1"
                              disabled={loading}
                            >
                              {loading ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                "Create Marketer"
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
